import {createSlice} from "@reduxjs/toolkit";
import { getCouponList, getActiveCouponList } from './action';

const initialState = {
	state: {
		items: [],
		meta: {},
		summary: {}
	},
	loading: true,
	error: ''
} as BaseState<CouponState>

const slice = createSlice({
	name: 'couponSlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getCouponList.pending, (state) => ({
				...state,
				loading: true
			})
		)
		builder.addCase(getCouponList.fulfilled, (state, action) => {
			const { items, summary, meta } = action.payload
				return {
					state: {
						items,
						summary,
						meta
					},
					loading: false,
					error: null
				}
			}
		)
		builder.addCase(getCouponList.rejected, (state) => ({
				...state,
				loading: false,
				error: 'Failed to get coupons, please try again'
			})
		)
		builder.addCase(getActiveCouponList.pending, (state) => ({
				...state,
				loading: true
			})
		)
		builder.addCase(getActiveCouponList.fulfilled, (state, action) => {
				const { items, meta } = action.payload
				return {
					state: {
						items,
						meta
					},
					loading: false,
					error: null
				}
			}
		)
		builder.addCase(getActiveCouponList.rejected, (state) => ({
				...state,
				loading: false,
				error: 'Failed to get coupons, please try again'
			})
		)
	}
})

export default slice
